import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite, Slider, Img } from '../../../../hybrid/wrappers';
import { t } from '../../../../common/components/T';
import OfficeConditionBlock from '../../../../hybrid/library/OfficeConditionBlock/OfficeConditionBlock';
import SpeedProgress from '../../../../hybrid/library/SpeedProgressAdmin';
import LineProgress from '../../../../hybrid/library/LineProgress';
import css from './ProgressBlock.module.scss';

const ProgressBlock = ({ rankData, trans }) => {
    return (
        <>
            <div className={css.userModalRangBlock}>
                <div className={css.userModalRangItem}>
                    <div className={css.userModalRangIcon}>
                        {rankData.current_rank && rankData.current_rank?.preview?.links?.preview ? (
                            <Img
                                className={css.userModalRangImg}
                                src={rankData.current_rank && rankData.current_rank?.preview?.links?.preview}
                            />
                        ) : rankData?.current_rank?.sort ? (
                            svgSprite('rankPlug', {
                                className: css.userModalRangImg
                            })
                        ) : (
                            svgSprite('rankNoRang', {
                                className: css.userModalRangImg
                            })
                        )}
                    </div>
                    <div className={css.userModalRangValue}>
                        {rankData.current_rank
                            ? rankData.current_rank.name
                            : t('user_modal_NoRank', 'Без ранга', 'widget', trans, 'userModal')}
                    </div>
                </div>
                {rankData.next_rank?.name !== rankData.current_rank?.name ? (
                    <>
                        <div className={css.userModalRangArrow}>
                            {svgSprite('angle-right', {
                                className: css.userModalCloseAngleRight
                            })}
                        </div>
                        <div className={css.userModalRangItem}>
                            <div className={css.userModalRangIcon}>
                                {rankData.next_rank && rankData.next_rank?.preview?.links?.preview ? (
                                    <Img
                                        className={css.userModalRangImg}
                                        src={rankData.next_rank && rankData.next_rank?.preview?.links?.preview}
                                    />
                                ) : rankData?.next_rank?.sort ? (
                                    svgSprite('rankPlug', {
                                        className: css.userModalRangImg
                                    })
                                ) : (
                                    svgSprite('rankNoRang', {
                                        className: css.userModalRangImg
                                    })
                                )}
                            </div>
                            <div className={css.userModalRangValue}>
                                {rankData.next_rank
                                    ? rankData.next_rank.name
                                    : t('user_modal_NoRank', 'Без ранга', 'widget', trans, 'userModal')}
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
            <div className={css.wrapSpeedProgressSlider}>
                {rankData?.conditions?.volumes && (
                    <Slider
                        props={{
                            dots: true,
                            arrows: false,
                            slidesToShow: rankData.conditions.volumes.length < 2 ? rankData.conditions.volumes.length : 2,
                            slidesToScroll: 2,
                            responsive: [
                                {
                                    breakpoint: 575,
                                    settings: {
                                        slidesToShow: rankData.conditions.volumes?.length > 1 ? 2 : 1,
                                        slidesToScroll: rankData.conditions.volumes?.length > 1 ? 2 : 1
                                    }
                                }
                            ]
                        }}
                    >
                        {rankData.conditions.volumes.map((quantityPVitem, idx) => (
                            <SpeedProgress
                                key={`quantityPVitem${idx}`}
                                target={quantityPVitem.target}
                                hasPV={quantityPVitem.accumulated}
                                title={quantityPVitem.symbol}
                                formatted_accumulated={quantityPVitem.formatted_accumulated}
                                formatted_left_to_accumulate={quantityPVitem.formatted_left_to_accumulate}
                                styles={{
                                    ...css,
                                    speedProgressComponent:
                                        rankData.conditions.volumes.length > 1
                                            ? css.speedProgressComponentMb
                                            : css.speedProgressComponent
                                }}
                            />
                        ))}
                    </Slider>
                )}
            </div>
            <div>
                {!!rankData.conditions?.next_rank_package && (
                    <OfficeConditionBlock
                        data={{
                            status: rankData?.conditions?.next_rank_package?.has_package,
                            text: ` ${t('user_modal_PackageAvailability', 'Наличие пакета', 'widget', trans, 'userModal')} «${
                                rankData?.conditions?.next_rank_package?.package.name
                            }» ${t('user_modal_orHigher', 'или выше', 'widget', trans, 'userModal')}`
                        }}
                    />
                )}
                {rankData && rankData.conditions && rankData.conditions.branches_with_rank ? (
                    <div className={css.mt3}>
                        <LineProgress
                            data={{
                                have: rankData.conditions.branches_with_rank.target_rank,
                                partners: {
                                    set: rankData?.conditions?.branches_with_rank?.number,
                                    max: rankData?.conditions?.branches_with_rank?.target_number
                                }
                            }}
                            compStyles={css}
                        />
                    </div>
                ) : null}
            </div>
        </>
    );
};
ProgressBlock.propTypes = {
    styles: PropTypes.object,
    nowStatus: PropTypes.string,
    nextStatus: PropTypes.string,
    partners: PropTypes.object
};
export default ProgressBlock;
